import * as React from 'react';
import JsonLd from '../../components/common/layouts/JsonLd';
import MetaTags from '../../components/common/layouts/MetaTags';
import MerchantShowPage, {
  PageProps as MerchantShowPageProps,
} from '../../components/merchants/show/MerchantShowPage';
import Area from '../../domain/entities/Area';
import implCategoryRepository from '../../infrastructure/repositories/MerchantCategoryRepository';
import implUCMerchantRepository from '../../infrastructure/repositories/UCMerchantRepository';
import { buildBreadCrumbs } from '../../utils/breadcrumbs';
import { PageContext } from '../_app';

interface Context extends PageContext {
  query: {
    publicId: string;
  };
}

export interface PageProps extends MerchantShowPageProps {
  area?: Area;
}

/**
 * Page Component
 */
class MerchantShow extends React.PureComponent<PageProps> {
  public static async getInitialProps(ctx: Context): Promise<PageProps> {
    const { query } = ctx;
    const layout = await implUCMerchantRepository().Layout(query.publicId);
    const pCategories = implCategoryRepository.Search();
    const contents = implUCMerchantRepository().TopContent(query.publicId);

    return Promise.all([pCategories, contents])
      .then(results => {
        const categories = results[0];
        const reviews = results[1].reviews;

        return {
          area: layout.area,
          categories,
          category: layout.category,
          merchant: layout.merchant,
          reviews,
          booking_page_count: layout.bookingServiceCount,
          post_count: layout.blogPostCount,
          product_count: layout.productCount,
        };
      })
      .catch(err => {
        throw err;
      });
  }

  public render() {
    const { merchant, area, category } = this.props;
    const breadcrumbs = buildBreadCrumbs(merchant, area, category);

    return (
      <>
        <MetaTags
          title={merchant.metaSetting.title || merchant.displayName}
          description={merchant.metaSetting.description || merchant.description}
          keywords={merchant.metaSetting.keyword || ''}
          thumbnailUrl={merchant.coverImage.url || ''}
          currentUrl={`/${merchant.publicId}`}
          noIndex={merchant.metaSetting.isNoIndex}
        />
        <MerchantShowPage {...this.props} breadcrumbs={breadcrumbs} />
        <JsonLd
          breadcrumbs={breadcrumbs}
          reviews={this.props.reviews}
          merchant={this.props.merchant}
        />
      </>
    );
  }
}

export default MerchantShow;
